(function () {
    'use strict';

    function RegisterCtrl(appData, authService, $state, toastr, $uibModal, utilService, $window) {
        var vm = this;

        vm.busy = false;
        vm.validationErrors = [];

        vm.roles = appData.applicationRoles;

        vm.registerData = {
            userName: '',
            password: '',
            role: ''
        };

        vm.register = function (form) {
            if (vm.busy) return;
            vm.busy = true;
            if (form.$valid) {
                authService.register(vm.registerData).then(function () {
                    $uibModal.open({
                        templateUrl: 'account/register/confirmation.html'
                    }).result.finally(function () {
                        $state.go('login');
                    });
                }, function (err) {
                    toastr.error('Unable to register.', 'Error');
                    vm.validationErrors = utilService.parseViewModelResponse(err, utilService.errorEnum.ALL);
                    $window.scroll(0, 0);
                    vm.busy = false;
                });
            } else {
                vm.busy = false;
            }
        };
    };

    angular
        .module('app')
        .controller('RegisterCtrl', ['appData', 'authService', '$state', 'toastr', '$uibModal', 'utilService', '$window', RegisterCtrl]);

})();